<h1 class="common-section-title">{{ lg.goodsBlock.heading }}</h1>
<div class="common-container">
  <div class="common-section-wrapper">
    <div class="goods-page__list">
      @for (good of goods; track good) {
        <bmcore-good-item [good]="good"> </bmcore-good-item>
      }
    </div>
  </div>
</div>
